import { render, staticRenderFns } from "./CholHamoedProgramTotals.vue?vue&type=template&id=75bdb502&"
import script from "./CholHamoedProgramTotals.vue?vue&type=script&lang=js&"
export * from "./CholHamoedProgramTotals.vue?vue&type=script&lang=js&"
import style0 from "./CholHamoedProgramTotals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports